import { cn } from "@/lib/utils";
import { motion } from "framer-motion";
import React from "react";

interface MarqueeProps {
    children: React.ReactNode;
    direction?: "left" | "right";
    speed?: number;
    pauseOnHover?: boolean;
    className?: string;
}

export const Marquee = ({
    children,
    direction = "left",
    speed = 50,
    pauseOnHover = true,
    className,
}: MarqueeProps) => {
    return (
        <div className={cn("group flex overflow-hidden p-2 [--gap:2rem] [gap:var(--gap)] user-select-none", className)}>
            <motion.div
                initial={{ x: 0 }}
                animate={{ x: "-100%" }}
                transition={{
                    repeat: Infinity,
                    ease: "linear",
                    duration: speed,
                }}
                className="flex shrink-0 flex-row justify-around [gap:var(--gap)] min-w-full"
            >
                {children}
            </motion.div>
            <motion.div
                initial={{ x: 0 }}
                animate={{ x: "-100%" }}
                transition={{
                    repeat: Infinity,
                    ease: "linear",
                    duration: speed,
                }}
                className="flex shrink-0 flex-row justify-around [gap:var(--gap)] min-w-full"
                aria-hidden
            >
                {children}
            </motion.div>
        </div>
    );
};
